// 视频分类管理
import http from "@/jslibs/axios/http";

// 视频分类列表
export const list = (data) => http.get(`/v1/cms/VideoCategory`, data);

// 视频分类添加
export const add = (data) => http.post(`/v1/cms/VideoCategory`, data);

// 视频分类编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/VideoCategory/${uuid}`, data);

// 视频分类详情
export const detail = ({ uuid, ...data }) => http.get(`/v1/cms/VideoCategory/${uuid}`, data);

// 视频分类删除
export const del = ({ uuid }) => http.delete(`/v1/cms/VideoCategory/${uuid}`);